import dayjs from 'dayjs';

import { cycloneApiClient } from '@/shared/api/core/axios-instance';

/** 백엔드에 따라 `group` 대신 `entityType` 등으로 올 수 있음 — `cycloneEntityCountsToChartData`에서 정규화 */
export type DashboardEntityCountItem = {
  count: number;
  day?: number;
  group?: string;
  entityType?: string;
  entity_type?: string;
  timestamp?: number;
};

export type DashboardEntityCountsResponse = {
  results: DashboardEntityCountItem[];
};

export const fetchDashboardEntityCounts = async (period: 7 | 14 | 30 | 90): Promise<DashboardEntityCountsResponse> => {
  const end = dayjs().valueOf();
  const start = dayjs().subtract(period, 'day').valueOf();

  const { data } = await cycloneApiClient.get<DashboardEntityCountsResponse>('/dashboard/entity-counts', {
    params: {
      start,
      end,
    },
  });

  return data;
};
